import React from 'react';
import { motion } from 'framer-motion';
import { BatteryChargingIcon, BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-84" data-mp="sa027qby5mqy">
      <div className="h-1 w-full bg-primary" aria-hidden="true" data-id="element-85" data-mp="nczt16jsw3vm" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-86" data-mp="3d1ikzavvpeny">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-primary bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-87" data-mp="3cz5ug9c21vza">
          <BatteryChargingIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-88" data-mp="399jppk78yr9a" /> {productBrand}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-89" data-mp="3ebioshvyf20f">
          <img src={productImage} alt="Battery Technology & Energy Storage Professional Edition: six volumes and five bonus resources covering fundamentals, chemistries, management systems, BESS, grid integration and safety" className="mx-auto w-full drop-shadow-2xl" data-id="element-90" data-mp="2qleoaje2bidn" />
        </motion.div>

        <div className="mt-9" data-id="element-91" data-mp="2ljgzl9mw7vdb">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-92" data-mp="2lmv4aoj14gnx">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-93" data-mp="na9xyj16r4ia">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/50 bg-surface px-3 py-2" data-id="element-94" data-mp="ddnhs7jt11ml">
              <Icon className="h-3.5 w-3.5 text-primary" aria-hidden="true" data-id="element-95" data-mp="1azkv7qjbugro" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}